import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('app.locations'),
      path: 'configurations',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/locations/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
